import { SMSService } from '@weave/schema-gen-ts/dist/schemas/sms/data/v4/sms_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaSMSDataV4Service = bindHTTP(SMSService);
export const serviceName = 'sms-data-v4' as const;
